/*
 * Copyright (c) 2026 Paxia AI Pty Ltd. All rights reserved.
 * This software is proprietary and confidential.
 * No part of this codebase may be copied, modified, published, distributed, sublicensed, or used without prior written permission from Paxia AI Pty Ltd.
 */

export function buildPositionRiskLevels(positions, symbol) {
  if (!Array.isArray(positions)) return [];
  const normalizedSymbol = String(symbol || '').toUpperCase();
  const levels = [];

  positions.forEach((position, index) => {
    const positionSymbol = String(position?.symbol || position?.instrument || '').toUpperCase();
    if (normalizedSymbol && positionSymbol !== normalizedSymbol) return;

    const identity = position?.ticket ?? position?.position_id ?? position?.trade_id ?? index;
    const labelSuffix = identity != null && identity !== '' ? ` ${identity}` : '';
    const stopLoss = Number(position?.sl ?? position?.stop_loss);
    const takeProfit = Number(position?.tp ?? position?.take_profit ?? position?.profit_target);

    if (Number.isFinite(stopLoss) && stopLoss > 0) {
      levels.push({ key: `${identity}:sl`, price: stopLoss, type: 'sl', title: `SL${labelSuffix}` });
    }
    if (Number.isFinite(takeProfit) && takeProfit > 0) {
      levels.push({ key: `${identity}:tp`, price: takeProfit, type: 'tp', title: `TP${labelSuffix}` });
    }
  });

  return levels;
}
